module.exports = __webpack_public_path__ + "static/media/Office.45e77834.jpg";